import { Flex, Typography } from '@banhala/ui-kit';
import React, { useMemo } from 'react';

export const LabelCount: React.FC<{
  label: string;
  count: number;
  isPercent?: boolean;
}> = props => {
  const label = useMemo(() => {
    if (props.isPercent) {
      return `${Math.floor(props.count)}%`;
    }
    const calcCount = () => {
      if (props.count >= 100000000) {
        return {
          value: (props.count / 100000000).toFixed(1),
          label: '억',
        };
      }
      if (props.count >= 10000) {
        return {
          value: (props.count / 10000).toFixed(1),
          label: '만',
        };
      }
      if (props.count >= 1000) {
        return {
          value: (props.count / 1000).toFixed(1),
          label: '천',
        };
      }
      return { value: props.count, label: '' };
    };
    const values = calcCount();
    return `${values.value}${values.label}`;
    // return numToKorean(calcCount(), 'float');
  }, [props.count, props.isPercent]);
  return (
    <Flex.Row gap={4}>
      <Typography type={'body3'} color={'content_secondary'}>
        {props.label}
      </Typography>
      <Typography type={'subtitle3'} color={'content_primary'}>
        {label}
      </Typography>
    </Flex.Row>
  );
};
